/*eslint constructor-super: off*/

import "document-register-element"
import { isFunction } from "lodash"

export default class WorkflowElement extends HTMLElement {
  constructor() {
    const self = super()
    const template = self.template(
      "Workflow/Graph",
      self.constructor.elementName
    )
    if (template) {
      self.innerHTML = template.innerHTML
      for (let key of Object.keys(template.attributes)) {
        self.setAttribute(
          template.attributes[key].name,
          template.attributes[key].value
        )
      }
    }

    self.initialize.apply(self, arguments)

    return self
  }

  initialize() {}

  empty() {
    this.children.forEach(child => child.remove())
  }

  find(query) {
    return this.querySelector(query)
  }

  findAll(query) {
    return [...this.querySelectorAll(query)]
  }

  get children() {
    return [...super.children]
  }

  setContent(node) {
    this.innerHTML = ""
    this.appendChild(node)
  }

  setContentOf(selector, node) {
    let child = this.find(selector)

    if (child) {
      child.innerHTML = ""
      child.appendChild(node)
    }
  }

  prependContent(selector = null, nodeOrFunc) {
    if (!nodeOrFunc) {
      nodeOrFunc = selector
      selector = undefined
    }

    let container = this
    let sibling = this.children[0]

    if (selector) {
      const realSibling = this.find(selector)
      if (realSibling) {
        sibling = realSibling
      }
    }

    if (isFunction(nodeOrFunc)) {
      nodeOrFunc = nodeOrFunc()
    }

    if (sibling) {
      container = sibling.parentElement
    }

    container.insertBefore(nodeOrFunc, sibling)
  }

  appendContent(selector = null, nodeOrFunc) {
    if (!nodeOrFunc) {
      nodeOrFunc = selector
      selector = undefined
    }

    let content = this
    if (selector) {
      content = this.find(selector)
    }

    if (isFunction(nodeOrFunc)) {
      nodeOrFunc = nodeOrFunc()
    }
    content.appendChild(nodeOrFunc)
  }

  template(templateName, nodeName) {
    const template = document.querySelector(
      `template[data-type="${templateName}"]`
    )
    if (!template) {
      return
    }

    const templateElement = template.content.querySelector(nodeName)

    if (!templateElement) {
      return
    }

    return templateElement
  }
}

customElements.get("workflow-element") ||
  customElements.define("workflow-element", WorkflowElement)
